/* eslint-disable */
import React from 'react';
import { useHistory } from 'react-router-dom';
import './R2RDomainTile.css';

const R2RDomainTile = ({ title = "Title", showBackButton = false, mainPagePath, detailState = {} }) => {
  const history = useHistory();

  const handleBackClick = () => {
    // history.goBack();
    if (mainPagePath) {
      history.push(mainPagePath, detailState);
    } else {
      history.goBack();
    }
  };

  return (
    <div className="r2r-domain-tile">
      <div className="r2r-domain-tile-header">{title}</div>
      {showBackButton && (
        <button className="r2r-back-button" onClick={handleBackClick}>
          ← Back
        </button>
      )}
    </div>
  );
};

export default R2RDomainTile;

